import React, { useCallback, useMemo } from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  SetActiveFilters,
  SetUrlPrefix,
  SetImgPrefix,
  SetSliderValueMinMax,
  SetIsExpanded,
  SetIsSearching,
  SetSliderValue,
  SetSearchWord,
  SetAsyncData,
  SetListingBanner,
  SetShowFilters,
  SetFiltersWithoutFilter,
  SetPrevProducts,
  SetProducts,
  SetFilters,
  SetResultsCount,
  SetMasterCategories,
  SetPages,
  SetPage,
  SetSuggestedWords,
} from "../../state/actions/index"
import "./NoProducts.css"
import Utils from "../../utils/Utils"
import axios from "axios"
import getSymbolFromCurrency from "currency-symbol-map"
import ProductsRecommendations from "../ProductsRecommendations/ProductsRecommendations"
import CategoriesRecommendations from "../CategoriesRecommendations/CategoriesRecommendations"

const NoProducts = () => {
  const noProducts = useSelector((state) => state.config.noProducts)
  const configFilters = useSelector((state) => state.config.filters)
  const activeFilters = useSelector((state) => state.activeFilters)
  const card = useSelector((state) => state.config.card)
  const placeholders = useSelector((state) => state.config.placeholders)
  const autocomplete = useSelector((state) => state.config.autocomplete)
  const currencyCode = useSelector((state) => state.config.priceGroup.currency)
  const priceFormat = useSelector((state) => state.config.priceGroup.format)
  const sliderValue = useSelector((state) => state.sliderValue)
  const sliderValueMinMax = useSelector((state) => state.sliderValueMinMax)
  const config = useSelector((state) => state.config)
  const display = useSelector((state) => state.config.display)
  const defaultMasterCategories = useSelector(
    (state) => state.defaultMasterCategories
  )
  const advancedCustomization = useSelector(
    (state) => state.advancedCustomization
  )
  const recommendationRules = useSelector(
    (state) => state.config.recommendationRules
  )
  const sort = useSelector((state) => state.sort)
  const show = useSelector((state) => state.config.show)
  const isMobile = useSelector((state) => state.isMobile)
  const products = useSelector((state) => state.products)
  const searchWord = useSelector((state) => state.searchWord)
  const dispatch = useDispatch()

  const queryOptions = useSelector((state) => state.config.queryOptions)
  var minChars = useMemo(
    () =>
      isMobile ? autocomplete.minChars.mobile : autocomplete.minChars.desktop,
    [isMobile, autocomplete]
  )
  var rows = useMemo(
    () => (isMobile ? queryOptions.rows.mobile : queryOptions.rows.desktop),
    [isMobile, queryOptions]
  )

  var currencySymbol = useMemo(
    () =>
      getSymbolFromCurrency(
        advancedCustomization
          ? advancedCustomization.currencyCode
          : currencyCode
      ),
    [advancedCustomization, currencyCode]
  )

  const categoryKey = useMemo(() => {
    var valueToReturn = ""
    Object.keys(configFilters).forEach((filter) => {
      if (configFilters[filter].isCategory) valueToReturn = filter
    })
    return valueToReturn
  }, [configFilters])

  const onWordClick = useCallback(
    (word) => {
      dispatch(SetSearchWord(word))
      dispatch(SetActiveFilters([]))
      dispatch(SetIsSearching(true))
      dispatch(SetAsyncData([]))
      var priceGroup = {}
      priceGroup.id =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
          ? window.AS_ADVANCED_CONFIG.visitorType
          : config.priceGroup.id
      priceGroup.currency =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
          ? window.AS_ADVANCED_CONFIG.currencyCode
          : config.priceGroup.currency
      var localSearchUrl = Utils.getSearchUrl(
        config.baseUrl,
        config.queryOptions,
        priceGroup,
        config.shopId,
        config.jsonFast
      )
      axios
        .get(
          Utils.insertWordInSearchUrl(
            localSearchUrl,
            word,
            [],
            sort,
            1,
            configFilters,
            rows
          )
        )
        .then((res) => {
          var response = res.data
          dispatch(SetIsExpanded({}))
          dispatch(SetPrevProducts(products))
          dispatch(
            SetProducts(
              Utils.refactorUrl(
                response.data,
                response.header.imagePrefix,
                response.header.urlPrefix,
                card.img,
                card.url
              )
            )
          )
          dispatch(SetSuggestedWords(response.suggestions))
          dispatch(SetResultsCount(response.header.results_count))
          dispatch(SetSliderValue(Utils.addSliderValue(response, sliderValue)))
          dispatch(
            SetSliderValueMinMax(
              Utils.addSliderValue(response, sliderValueMinMax)
            )
          )
          dispatch(SetFilters(response))
          dispatch(
            SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
          )
          dispatch(SetPage(1))
          dispatch(SetListingBanner(response.banners[0]))
          dispatch(
            SetMasterCategories(
              response.stats[categoryKey]
                ? Utils.refactorMasterCategories(
                    Object.keys(response.stats[categoryKey])
                  )
                : defaultMasterCategories
            )
          )
          dispatch(SetUrlPrefix(response.header.urlPrefix))
          dispatch(SetImgPrefix(response.header.imagePrefix))
          if (config.webhook.key !== "")
            Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
              (value) => dispatch(SetAsyncData(value.asyncData))
            )
        })
        .finally(() => dispatch(SetIsSearching(false)))
    },
    [
      dispatch,
      defaultMasterCategories,
      sort,
      sliderValue,
      rows,
      sliderValueMinMax,
      config,
      configFilters,
      products,
      categoryKey,
      card,
    ]
  )

  const removeFilter = useCallback(
    (activeFilter) => {
      var tempActiveFilters = Utils.removeActiveFilter(
        activeFilters,
        activeFilter,
        configFilters
      )
      dispatch(SetIsSearching(true))
      if (
        tempActiveFilters.length === 0 &&
        searchWord.length < minChars &&
        show.type === "input" &&
        !isMobile
      )
        Utils.closeLayer(display, window.innerWidth <= 768)
      dispatch(SetAsyncData([]))
      var priceGroup = {}
      priceGroup.id =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.visitorType
          ? window.AS_ADVANCED_CONFIG.visitorType
          : config.priceGroup.id
      priceGroup.currency =
        window.AS_ADVANCED_CONFIG && window.AS_ADVANCED_CONFIG.currencyCode
          ? window.AS_ADVANCED_CONFIG.currencyCode
          : config.priceGroup.currency
      var localSearchUrl = Utils.getSearchUrl(
        config.baseUrl,
        config.queryOptions,
        priceGroup,
        config.shopId,
        config.jsonFast
      )
      axios
        .get(
          Utils.insertWordInSearchUrl(
            localSearchUrl,
            searchWord,
            tempActiveFilters,
            sort,
            1,
            configFilters,
            rows
          )
        )
        .then((res) => {
          var response = res.data
          dispatch(SetIsExpanded({}))
          dispatch(SetActiveFilters(tempActiveFilters))
          dispatch(SetPrevProducts(products))
          dispatch(
            SetProducts(
              Utils.refactorUrl(
                response.data,
                response.header.imagePrefix,
                response.header.urlPrefix,
                card.img,
                card.url
              )
            )
          )
          dispatch(SetSuggestedWords(response.suggestions))
          dispatch(SetResultsCount(response.header.results_count))
          if (searchWord.length < minChars && tempActiveFilters.length === 0)
            dispatch(SetShowFilters(false))
          if (activeFilter.key === "sellingPrice") {
            dispatch(
              SetSliderValue(Utils.addSliderValue(response, sliderValue))
            )
            dispatch(
              SetSliderValueMinMax(
                Utils.addSliderValue(response, sliderValueMinMax)
              )
            )
          }
          if (
            Utils.isMultiChoiceFilter(configFilters, activeFilter.key) &&
            tempActiveFilters
              .map((activeFilter) => activeFilter.key)
              .includes(activeFilter.key) &&
            tempActiveFilters.length > 0
          )
            dispatch(
              SetFiltersWithoutFilter({
                response: response,
                filterType: activeFilter.key,
              })
            )
          else dispatch(SetFilters(response))
          dispatch(
            SetPages(parseInt((response.header.results_count - 1) / rows) + 1)
          )
          dispatch(SetPage(1))
          dispatch(SetListingBanner(response.banners[0]))
          dispatch(
            SetMasterCategories(
              response.stats[categoryKey]
                ? Utils.refactorMasterCategories(
                    Object.keys(response.stats[categoryKey])
                  )
                : defaultMasterCategories
            )
          )
          dispatch(SetUrlPrefix(response.header.urlPrefix))
          dispatch(SetImgPrefix(response.header.imagePrefix))
          if (config.webhook.key !== "")
            Utils.getAsyncData(config.webhook, response.data, priceGroup).then(
              (value) => dispatch(SetAsyncData(value.asyncData))
            )
        })
        .finally(() => dispatch(SetIsSearching(false)))
    },
    [
      dispatch,
      activeFilters,
      searchWord,
      isMobile,
      display,
      config,
      show,
      rows,
      defaultMasterCategories,
      sort,
      sliderValue,
      sliderValueMinMax,
      categoryKey,
      configFilters,
      products,
      minChars,
      card,
    ]
  )
  return (
    <div className="no-products">
      <div className="container">
        <div
          className="img"
          style={
            noProducts.img !== ""
              ? { backgroundImage: "url(" + noProducts.img + ")" }
              : {}
          }
        ></div>
        {activeFilters.length === 0 ? (
          <div className="text">
            <span>
              {placeholders.noProducts}
              <b>{searchWord}</b>.<br />
              {noProducts.mostSearched.length > 0
                ? placeholders.popularSearch
                : ""}
              <br />
            </span>
            {activeFilters &&
            activeFilters.length === 0 &&
            recommendationRules?.length > 0 ? (
              <div>
                {recommendationRules?.map((rule) => {
                  const timeCondition =
                    rule?.condition?.conditions?.[0]?.conditions?.[0]
                  let timeIntervalOk = false
                  if (timeCondition?.type === "timeInterval") {
                    if (
                      timeCondition.from * 1000 <= new Date().getTime() &&
                      new Date().getTime() <= timeCondition.to * 1000
                    ) {
                      timeIntervalOk = true
                    }
                  } else {
                    timeIntervalOk = true
                  }

                  if (rule?.isActive && !!timeIntervalOk) {
                    if (rule?.extra?.type === "layer") {
                      const visualType =
                        rule?.extra?.noResult?.visualizationType
                      if (visualType === "carousel") {
                        return <ProductsRecommendations recommendation={rule} />
                      }
                    } else {
                      return <></>
                    }
                  }
                })}
              </div>
            ) : null}
            {noProducts.mostSearched.map((item, index) => (
              <span key={"most_searched_" + index}>
                <span className="word" onClick={() => onWordClick(item)}>
                  {item}
                </span>{" "}
                {index < noProducts.mostSearched.length - 1 ? ", " : ""}
              </span>
            ))}
            <br />
          </div>
        ) : (
          <div className="text">
            {placeholders.noMatch} <br />
            {placeholders.noMatchFilters}
            <div className="active-filters-container">
              {activeFilters.map((activeFilter, index) => (
                <div
                  className="active-filter"
                  onClick={() => removeFilter(activeFilter)}
                  key={"active_filter_" + index}
                >
                  <span className="value">
                    {configFilters[activeFilter.key]?.isCategory ? (
                      Utils.returnLastCategory(activeFilter.value)
                    ) : configFilters[activeFilter.key]?.type === "slider" ? (
                      Utils.setNumberFormat(
                        activeFilter.value[0],
                        priceFormat.decimals,
                        priceFormat.dec_divider,
                        priceFormat.migl_divider
                      ) +
                      currencySymbol +
                      " - " +
                      Utils.setNumberFormat(
                        activeFilter.value[1],
                        priceFormat.decimals,
                        priceFormat.dec_divider,
                        priceFormat.migl_divider
                      ) +
                      currencySymbol
                    ) : configFilters[activeFilter.key]?.type === "rating" ? (
                      <span className="icon-container">
                        <span>{activeFilter.value[0]}</span>
                        <span className="rating-icon"></span>
                      </span>
                    ) : (
                      activeFilter.value
                    )}
                  </span>
                  <span className="icon close"></span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default NoProducts
